export const navbarLogo = process.env.PUBLIC_URL + '/img/logoElikia.png';
// export const footerLogo = process.env.PUBLIC_URL + '/img/LogoEasyFunding.png';
export const logoBlanc = process.env.PUBLIC_URL + '/img/ElikiaBlanc.png';